export class BidIncrementalDto {
  upToAmount?: number;
  incrementValue?: number;
}
